module.exports = __webpack_public_path__ + "img/vue3-web3-2.3135cae8.jpg";